import Footer from '../components/Footer';
import safetyLogo from '../images/logo_safety100_erd_light.png';
import {useNavigate} from 'react-router-dom';
export default function Foreigner() {
    const navigate = useNavigate();

    const firstStepHandler = () => { navigate('/signup-foreigner')};

    return (
        <div className='w-screen h-[calc(100dvh)] flex flex-col items-center relative'>
            <div className='flex flex-col items-center justify-center'>
                <img className='mb-[8rem] md:mb-[300px] mt-[33%] md:mt-[247px] w-[65%] md:w-[487px]' src={safetyLogo} alt='logo' />
                <div className='w-[100%] md:w-[600px] text-center'>
                    <p className='text-20 font-preLight md:text-40'>UECO conducts</p>
                    <p className='text-20 font-preLight md:text-40 mt-[0.5rem]'>safety training <span className='text-18 md:text-40'>(TBM)</span> before work</p>
                    <p className='text-20 font-preLight md:text-40 mt-[0.5rem]'>for a safe construction site.</p>
                    <p className='text-20 font-preLight md:text-40 mt-[1.5rem]'>Please follow the</p>
                    <p className='text-20 font-preLight md:text-40 mt-[0.5rem]'>progress afterwards.</p>
                    <button onClick={firstStepHandler} className='md:mt-[75px] text-20 md:text-37 leading-18 md:leading-36 w-full py-[0.7rem] md:py-[30px] outline-none rounded-[5px] md:rounded-[12px] mt-[1.4rem] bg-gradient-to-r from-gdFrom to-gdTo'>OK</button>
                </div>
            </div>
            <Footer/>
        </div>
    );
}